import { allValues, Rights } from '../rights';

export const NURSE_RIGHTS = Object.freeze([
  Rights.RESIDENTS.READ.key,
  Rights.RESIDENTS.WRITE.key,
  ...allValues(Rights.RESIDENTS.GENERAL),
  Rights.RESIDENTS.CONTRACT.READ.key,
  ...allValues(Rights.RESIDENTS.CHECKLIST),
  ...allValues(Rights.RESIDENTS.CONTACTS),
  ...allValues(Rights.RESIDENTS.CONSULTATION),
  ...allValues(Rights.RESIDENTS.UTILS),
  ...allValues(Rights.RESIDENTS.PASTORAL_CARE),
  ...allValues(Rights.RESIDENTS.DOCUMENT_MANAGEMENT),
  Rights.RESIDENTS.FILES.READ.key,
  Rights.RESIDENTS.FILES.WRITE.key,
  ...allValues(Rights.BASE_DATA.DOCTORS),
  Rights.BASE_DATA.INSURANCE.READ.key,
  Rights.BASE_DATA.SUPERVISOR.READ.key,
  Rights.CARE.READ.key,
  Rights.CARE.WRITE.key,
  ...allValues(Rights.CARE.TASKS),
  ...allValues(Rights.CARE.TASKS_EXTENDED),
  ...allValues(Rights.CARE.EXECUTION),
  ...allValues(Rights.CARE.EXECUTION_EXTENDED),
  Rights.CARE.ABSENCE.key,
  Rights.CARE.REPORT.READ.key,
  ...allValues(Rights.CARE.ASSESSMENT),
  ...allValues(Rights.CARE.CONSULTATION_FORM),
  ...allValues(Rights.CARE.MOVEMENT_STATUS),
  ...allValues(Rights.CARE.BIOGRAPHY),
  ...allValues(Rights.CARE.DATA_COLLECTION),
  ...allValues(Rights.CARE.DECUBITUS_RISK),
  ...allValues(Rights.CARE.NUTRITION_PROTOCOL),
  ...allValues(Rights.CARE.CASE_DISCUSSION),
  Rights.CARE.INDICATORS.READ.key,
  ...allValues(Rights.CARE.MEDICATION_ORDER),
  ...allValues(Rights.CARE.MEDICATION),
  ...allValues(Rights.CARE.NURSING_REPORT),
  Rights.CARE.CARE_PLAN_SUPERVISOR.key,
  ...allValues(Rights.CARE.CARE_PLAN),
  ...allValues(Rights.CARE.NURSE_VISIT),
  Rights.CARE.CARE_ROUNDS.READ.key,
  ...allValues(Rights.CARE.PAIN_PROTOCOL),
  ...allValues(Rights.CARE.SOCIAL_CARE),
  Rights.CARE.SOCIAL_CARE_GROUP.key,
  ...allValues(Rights.CARE.FALL_PROTOCOL),
  ...allValues(Rights.CARE.FALL_RISK),
  ...allValues(Rights.CARE.VITAL_INFORMATIONS),
  ...allValues(Rights.CARE.DOCTORS_DIAGNOSIS),
  ...allValues(Rights.CARE.VISIT_SHEET),
  ...allValues(Rights.CARE.VITAL_SIGNS),
  ...allValues(Rights.CARE.WOUND_DOCUMENTATION),
  Rights.ADMINISTRATION_AND_INVOICING.PAYER.READ.key,
  Rights.GENERAL.CASH_AMOUNT.READ.key,
  Rights.GENERAL.CALENDAR.READ.key,
  Rights.GENERAL.CALENDAR.WRITE.key,
  ...allValues(Rights.GENERAL.CONTACTS),
  ...allValues(Rights.GENERAL.MESSAGES),
  ...allValues(Rights.LISTS),
  Rights.ROSTER.ACCESS.LIMITED_READ.key,
  Rights.ROSTER.WEEK_PLAN.key,
  Rights.ROSTER.VACATION_SCHEDULE.READ.key,
  ...allValues(Rights.CARE.GENERAL_ORDER),
]);
